var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-width"},[_c('div',{staticClass:"four-o-four"},[_c('h1',{staticClass:"title"},[_vm._v("404")]),_vm._v(" "),_c('p',{staticClass:"sorry"},[_vm._v(_vm._s(_vm.$t('doesNotExist')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81b5bbfc","hasScoped":true,"transformToRequire":{"vue-h-zoom":["image","image-full"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/404.vue
// module id = null
// module chunks = 